module.exports = __webpack_public_path__ + "img/arrownpx.763beafe.png";